<template>
  <div class="privacy-policy">
    <h1>Politique de Confidentialité</h1>

    <section>
      <h2>Introduction</h2>
      <p>
        La confidentialité de vos données est une priorité. L'application
        <strong>Event</strong> s'engage à protéger les informations personnelles des utilisateurs
        lors de la gestion et de la participation à des événements.
      </p>
      <p>
        Cette politique détaille les types de données collectées, leur usage, leur conservation et
        les droits des utilisateurs.
      </p>
    </section>

    <section>
      <h2>Collecte des Renseignements Personnels</h2>
      <p>
        Nous collectons les informations suivantes lors de l'inscription ou de l'utilisation de
        l'application :
      </p>
      <ul>
        <li>Nom et prénom</li>
        <li>Adresse e-mail</li>
        <li>Numéro de téléphone</li>
        <li>Photo de profil (optionnelle)</li>
        <li>Informations sur l’événement (billets réservés, événements assistés, etc.)</li>
        <li>Données de localisation (si activé pour certains événements ou fonctions de scan)</li>
      </ul>
      <p>Ces données sont nécessaires pour :</p>
      <ul>
        <li>Gérer les inscriptions aux événements</li>
        <li>Émettre et valider les billets numériques</li>
        <li>Assurer une communication efficace avec les participants</li>
        <li>Faciliter la sécurité et la gestion sur place via la géolocalisation (si activée)</li>
      </ul>
    </section>

    <section>
      <h2>Utilisation des Informations</h2>
      <p>Les données collectées sont utilisées pour :</p>
      <ul>
        <li>Permettre l’accès et la gestion de votre compte</li>
        <li>Gérer vos participations, réservations et billets</li>
        <li>Communiquer avec vous concernant les événements</li>
        <li>Assurer la sécurité et la bonne organisation des événements</li>
      </ul>
      <p>
        Vos informations ne sont pas vendues ou utilisées à des fins publicitaires sans votre
        consentement.
      </p>
    </section>

    <section>
      <h2>Protection des Données</h2>
      <p>
        Nous mettons en place des mesures de sécurité techniques et organisationnelles pour protéger
        vos données contre l’accès non autorisé, la modification ou la suppression.
      </p>
      <p>
        Les données sont conservées uniquement pendant la durée nécessaire à leur traitement, puis
        supprimées ou anonymisées.
      </p>
    </section>

    <section>
      <h2>Données de Localisation</h2>
      <p>Certains événements peuvent nécessiter une vérification de votre position pour :</p>
      <ul>
        <li>Valider votre présence lors d’un événement</li>
        <li>Débloquer certaines fonctionnalités géolocalisées (ex : scan à l’entrée)</li>
      </ul>
      <p>
        Ces données ne sont utilisées qu’avec votre accord et sont supprimées à la fin de la
        session.
      </p>
    </section>

    <section>
      <h2>Vos Droits</h2>
      <p>Vous avez le droit de :</p>
      <ul>
        <li>Consulter vos données personnelles</li>
        <li>Demander leur correction ou leur suppression</li>
        <li>Vous opposer à leur traitement</li>
        <li>Supprimer votre compte à tout moment</li>
      </ul>
      <p>
        Pour toute demande, contactez-nous à
        <a href="mailto:support@eventapp.com">support@eventapp.com</a>.
      </p>
    </section>

    <section>
      <h2>Mises à Jour</h2>
      <p>
        Nous nous réservons le droit de modifier cette politique en cas de changements
        réglementaires ou techniques. Nous vous informerons de toute mise à jour importante.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
}
</script>

<style scoped>
.privacy-policy {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}
.privacy-policy h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}
.privacy-policy h2 {
  font-size: 1.5em;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}
.privacy-policy p {
  margin-bottom: 1em;
}
.privacy-policy ul {
  margin: 1em 0;
  padding-left: 1.5em;
}
.privacy-policy ul li {
  margin-bottom: 0.5em;
}
</style>
